<template>
    <div>
        <el-card>
            <el-table :data="detail.notice">

                <el-table-column label="消息标题" prop="title"></el-table-column>

                <el-table-column label="接收者" prop="to_user"></el-table-column>

                <el-table-column label="消息类型" prop="noticeType"></el-table-column>

                <el-table-column label="发送人" prop="createUser"></el-table-column>

                <el-table-column label="创建时间" prop="createTime"></el-table-column>

                <el-table-column label="发送时间" prop="serialNumber"></el-table-column>

                <el-table-column label="发送状态" prop="status"></el-table-column>

                <el-table-column label="备注" prop="comment"></el-table-column>
            </el-table>
        </el-card>
    </div>
</template>

<script>
export default {
    props: {
        detail: Object
    }
}
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>